export const displayPercentageDiscount = (percentage: number) => {
  if (percentage > 0) {
    return `-${percentage}%`;
  }
  if (percentage < 0) {
    return `+${percentage * -1}%`;
  }
  return '0%';
};
